// ----- State -----
const initialState = {
  lng: "en",
};

// ----- Types -----
// CHANGE LANGUAGE
const LANGUAGE_CHANGED = "LANGUAGE_CHANGED";

// ----- Reducer -----
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LANGUAGE_CHANGED:
      return {
        ...state,
        lng: action.payload.lng,
      };
    default:
      return state;
  }
}

// ----- Actions -----
// CHANGE LANGUAGE
export const changeLanguage = (lng) => (dispatch) => {
  dispatch({
    type: LANGUAGE_CHANGED,
    payload: {
      lng,
    },
  });
};
